/* import __COLOCATED_TEMPLATE__ from './workspaces-list.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();